import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDashboardData } from '_redux/modules/dashboard'
import dashBoardApi from '../../../api/dashBoard'
import { DASHBOARD_TIME_RANGE, DASHBOARD_RANGE_API } from '../../../utils/constant'

const getApiRange = (timeFilter, start, end) => {
  if (timeFilter === DASHBOARD_TIME_RANGE.DAYS_90) return DASHBOARD_RANGE_API.YEAR
  if (timeFilter === DASHBOARD_TIME_RANGE.THIS_WEEK) return DASHBOARD_RANGE_API.WEEK
  if (timeFilter === DASHBOARD_TIME_RANGE.THIS_MONTH) return DASHBOARD_RANGE_API.MONTH

  if (timeFilter === DASHBOARD_TIME_RANGE.CUSTOM && start && end) {
    const diffDays = Math.ceil((end - start) / (24 * 60 * 60))
    if (diffDays <= 7) return DASHBOARD_RANGE_API.WEEK
    if (diffDays <= 62) return DASHBOARD_RANGE_API.MONTH
    return DASHBOARD_RANGE_API.YEAR
  }

  return null
}

export const useDashboardData = (groupId, filters, isViewAll) => {
  const dispatch = useDispatch()
  const reduxData = useSelector((state) => state.dashBoard.dashboardData)
  const cachedGroupId = useSelector((state) => state.dashBoard.cachedGroupId)
  const cachedFilters = useSelector((state) => state.dashBoard.cachedFilters)
  const cachedIsViewAll = useSelector((state) => state.dashBoard.cachedIsViewAll)
  const [loading, setLoading] = useState(false)

  const isCacheValid = groupId === cachedGroupId &&
                       isViewAll === cachedIsViewAll &&
                       JSON.stringify(filters) === JSON.stringify(cachedFilters)

  const data = isCacheValid && reduxData ? reduxData : {}

  useEffect(() => {
    const fetchDashboard = async () => {
      if (!groupId || !filters) return
      if (isCacheValid) return

      try {
        setLoading(true)
        const range = getApiRange(filters?.time, filters?.start, filters?.end)
        const response = isViewAll
          ? await dashBoardApi.getDataGroupDashboard(groupId, range, filters)
          : await dashBoardApi.getDataDashboard(groupId, range, filters)
        const responseData = response?.data || {}
        dispatch(setDashboardData(responseData, groupId, filters, isViewAll))
      } catch (error) {
        console.error('Failed to fetch dashboard data:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchDashboard()
  }, [groupId, filters, isViewAll, isCacheValid, dispatch])

  return {
    data,
    loading,
  }
}
